import instanceQuery from '../../../graphql/queries/purchases/PurchaseEdiConfiguration.graphql';
import workspaceQuery from '../../../graphql/queries/purchases/PurchaseEdiConfigurationWorkspaceQuery.graphql';
import defaultQuery from '../../../graphql/queries/purchases/PurchaseEdiConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/purchases/PurchaseEdiConfigurationMutation.graphql';
import listQuery from '../../../graphql/queries/purchases/PurchaseEdiConfigurationListQuery.graphql';
import fragment from '../../../graphql/fragments/purchases/PurchaseEdiConfigurationFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const PurchaseEdiConfiguration: EntityType = {
  type: 'PurchaseEdiConfiguration',
  title: 'Purchase Edi Configuration',
  formTitle: 'Edi Configuration',
  formUrl: '/Purchasing/EdiConfig/Details/',
  workspaceUrl: '/Purchasing/EdiConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'PURCHASE_EDI_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default PurchaseEdiConfiguration;
